// @ts-nocheck
import { runChatBox } from './runChatBox.js'

export const makeInitChat = (lang, metaUrl) => {
  const _initChat = async options => {
    return runChatBox(lang, { style: {} }, window, options)
  }

  // autostart from snippet
  let str = metaUrl
  let idx = str.indexOf('#')
  // console.log("META URL : ", metaUrl)
  
  if (idx !== -1) {
    const params = JSON.parse(decodeURIComponent(str.substring(idx + 1)))
    // console.log("PARAMS u makeInitChat: ", params)
    _initChat(params)
  }
  return _initChat
}
